import React from 'react'
import cx from 'classnames'
import Grid from '@material-ui/core/Grid'
import { CaThemeProvider } from 'components/redesign/CaThemeProvider'
import { AnnouncementsSkeleton, StoriesSkeleton } from 'pages/dashboard/Skeleton'
import Hidden from '@material-ui/core/Hidden'
import AnnouncementsHeader from 'pages/dashboard/AnnouncementsHeader'

const DashboardSkeleton = ({ isLogged = true, windowHeight, headerHeight = 118 }) => (
  <div
    className='w-100 overflow-y-auto bg-ghost-grey flex justify-center scrolling-container flex-wrap'
    style={{ maxHeight: `${windowHeight - headerHeight}px` }}
  >
    <div className='grow-1 shrink-1 basis0 ph0 ma0'>
      <div className='h-100 mb8'>
        <div className='bg-ghost-grey'>
          <div className='bg-white relative pt4'>
            <ViewLatestUpdatesLink />
          </div>
          <div className={cx('layout-width-constraint bg-ghost-grey', { 'pt0 pb8': isLogged, pv0: !isLogged })}>
            <CaThemeProvider>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={9}>
                  <div className='bt-thick bt--light-sea-green-2'>
                    <StoriesSkeleton />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={3}>
                  <ContentPanelsWrapperSkeleton />
                </Grid>
              </Grid>
            </CaThemeProvider>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const ContentPanelsWrapperSkeleton = () => {
  return (
    <div className='bg-ghost-grey'>
      <Hidden mdDown>
        <AnnouncementsHeader />
      </Hidden>
      <>
        <Hidden mdDown>
          <AnnouncementsSkeleton maxHeight={1712} />
        </Hidden>
        <Hidden lgUp>
          <AnnouncementsSkeleton maxHeight={595} />
        </Hidden>
      </>
    </div>
  )
}

const ViewLatestUpdatesLink = () => (
  <div className='layout-width-constraint ml2-m flex min-h3 pb4 pb0-t pr6 flex-column-reverse-t items-center items-stretch-t'>
    <div className='flex grow-0 shrink-0 items-center mt6-t'>
      <h4 className='black b f3 mv0 ml4 ml6-m mr6 grow-0 shrink-0'>Latest News</h4>
      <a href={null} className='dib f7 mt4 pointer no-underline hover-underline'>View all News</a>
    </div>
    <div className='basis0 grow-1 shrink-1 h3 min-h2 max-h8-t ml6 mr4 -mb2 ml0-t pv2 pv0-t'>
      <NewsTickerSkeleton />
    </div>
  </div>
)

const NewsTickerSkeleton = () => (
  <div className='bg-twilight-grey h-100 flex items-center'>
    <div className='h-100 bg-light-sea-green-2 ph4 white f5 flex items-center grow-0 shrink-0'>Updates</div>
    <div className='black shrink-1 grow-1 basis0 relative overflow-hidden h-100 f6 w-100' />
  </div>
)

export default DashboardSkeleton
